import { render, staticRenderFns } from "./SampleHomeworkEdit.vue?vue&type=template&id=b3fa0e66&scoped=true&"
import script from "./SampleHomeworkEdit.vue?vue&type=script&lang=js&"
export * from "./SampleHomeworkEdit.vue?vue&type=script&lang=js&"
import style0 from "./SampleHomeworkEdit.vue?vue&type=style&index=0&id=b3fa0e66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fa0e66",
  null
  
)

export default component.exports